import React from "react";
import styled from "styled-components";

export const Text = styled((props) => <p {...props} />).attrs((props) => ({
  automationid:
    props.automationid ||
    `SalesLead_p_${props?.automationidattr?.replace(/ /g, "")}_1"`,
}))`
  font-weight: ${(props) => props.fontWeight || 400};
  color: ${(props) => props.color || "#282828"};
  margin-bottom: 0 !important;
  line-height: ${(props) => props.lineheight || 1.6};
  margin-top: 0 !important;
  font-size: ${(props) => props.fontSize || "1rem"};
  text-align: ${(props) => props.aligntext || "left"};
  font-family: "Roboto";
  padding-left: ${(props) => props.paddingLeft || 0};
`;
